import { Component, EventEmitter, Output, Input, ViewChild, LOCALE_ID } from "@angular/core";
import { CustomerAppointment, CustomerAppointmentLazy, CustomerAppointmentLazyOut, CustomerAppointmentLazySearch } from "src/classes/Diary/CustomerAppointment";
import { HttpServiceDiary } from "src/app/services/Diary/http/http.service_Diary";
import { NGXLogger } from "ngx-logger";
import { DataView } from "primeng/dataview";
import { AppointmentData } from "src/classes/Diary/Appointment";
import { Config } from "src/classes/Common/ConfigData";
import { registerLocaleData } from "@angular/common";
import localeHe from "@angular/common/locales/he";
import { NgForm, NgModel } from "@angular/forms";
import { LazyLoadEvent } from "primeng/api";

registerLocaleData(localeHe, "he");

interface Select {
    id: number;
    name: string;
}

@Component({
    selector: "app-create-app-customer",
    templateUrl: "./create-app-customer.component.html",
    styleUrls: ["./create-app-customer.component.css"],
    providers: [{ provide: LOCALE_ID, useValue: "he" }]
})
export class CreateAppCustomerComponent {
    @Input() appDataTemp: AppointmentData;
    @Input() config: Config;

    @Output() onChangeCustomer: EventEmitter<CustomerAppointment> = new EventEmitter<CustomerAppointment>();
    @Output() eventTitleChange: EventEmitter<string> = new EventEmitter<string>();

    // Lazy loading
    // loadinglazy: boolean = false;
    customerAppointmentLazy: CustomerAppointmentLazy = new CustomerAppointmentLazy();
    customerAppointmentLazySearch: CustomerAppointmentLazySearch = new CustomerAppointmentLazySearch();
    totalRecords: number = 0;
    lazyLoadParams: LazyLoadEvent;
    filterTimeout: ReturnType<typeof setTimeout> | null = null;

    customers: CustomerAppointment[];
    // initialCustomers: CustomerAppointment[];
    rows: number = 50;
    state: "loading" | "loaded" | "noresults" | "noclients" = "loading";
    filterValue: string = "";
    isAddButtonVisible: boolean = true;
    isAddingNewClient: boolean = false;
    newCustomer: CustomerAppointment | null = null;
    firstNameValue: string = "";
    lastNameValue: string = "";
    pelephoneValue: string = "";
    sex: number = 0;
    sexData: Select[] = [
        {
            id: 0,
            name: "בחר"
        },
        {
            id: 1,
            name: "לא מוגדר"
        },
        {
            id: 2,
            name: "אישה"
        },
        {
            id: 3,
            name: "גבר"
        }
    ];
    isFormValid: boolean = true;

    @ViewChild("dataView", { static: false }) dataView: DataView;

    constructor(
        private httpService: HttpServiceDiary,
        private logger: NGXLogger
    ) { }

    // Function that works on the opening of this step
    initialize(isCreatingNewEvent: boolean = true): void {
        if (isCreatingNewEvent) {
            // this.state = "loading";

            // this.httpService.getCustomersAppointment()
            //     .subscribe((data: CustomerAppointment[]): void => {
            //         data = data.map((customer: CustomerAppointment): CustomerAppointment => ({
            //             ...customer,
            //             birthDay: customer.birthDay as number < 10 ? "0" + customer.birthDay : customer.birthDay,
            //             birthMonth: customer.birthMonth as number < 10 ? "0" + customer.birthMonth : customer.birthMonth,
            //             isBirthDay: (
            //                 customer.birthDay
            //                 && customer.birthMonth
            //                 && customer.birthDay == (this.appDataTemp.start as Date).getDate()
            //                 && customer.birthMonth == (this.appDataTemp.end as Date).getMonth() + 1
            //             ),
            //         }));


            //         this.customers = [...data];
            //         this.initialCustomers = [...data];
            //         console.log("Count of customers for appointment: " + this.customers.length);

            //         // Set one of the states when the list is loaded
            //         if (this.customers.length == 0) {
            //             this.state = "noclients";
            //         }
            //         else {
            //             this.state = "loaded";
            //         }
            //     }, error => {
            //         console.log(error);
            //         this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            //     });
        }

        this.eventTitleChange.emit("בחירת לקוח");

        this.filterValue = "";
        // if (!isCreatingNewEvent) {
        setTimeout(() => {
            this.filterByInput();
        }, 0);
        // }

        this.isAddButtonVisible = true;

        this.isAddingNewClient = false;
        this.newCustomer = null;
    }

    // Disable controls while loading data
    // isControlsDisabled(): boolean {
    //     return this.state == "loading";
    // }

    // Disable controls when clients have not been loaded
    isFiltersDisabled(): boolean {
        return this.state == "noclients";
    }

    // Function that scrolls to the top of the list when changing the page
    onPageChange(): void {
        this.dataView.el.nativeElement.children[0].scrollTo({ top: 0 });
        this.state = "loading";
    }

    // Returns client image link
    getClientImageSrc(customer: CustomerAppointment): string {
        return !customer.imagePath ? "assets/img/client-avatar.png" : "https://optimusb12023.s3.eu-north-1.amazonaws.com/" + this.config.remotebusid + "/clients/" + customer.customerId + "/" + customer.imagePath;
    }

    // Clear the image path if the client image was not loaded to set the default image
    clearImagePath(id: number): void {
        this.customers.find((customer: CustomerAppointment) => customer.customerId == id).imagePath = "";
    }

    // Select the customer
    getCustomer(customerId: number): void {
        this.onChangeCustomer.emit(this.customers.find((customer: CustomerAppointment) => customer.customerId == customerId));
    }

    // Filter the list of customers by entered value
    filterByInput(): void {
        if (this.filterTimeout) {
            clearTimeout(this.filterTimeout);
        }

        this.state = "loading";
        this.lazyLoadParams.first = 0;
        this.dataView.first = 0;

        this.filterTimeout = setTimeout(() => {
            this.loadCustomersLazyAll();
        }, 300);

        // this.customers = this.initialCustomers;

        // let value = this.filterValue.toLowerCase();

        // this.customers = this.customers.filter((client: CustomerAppointment) => {
        //     if (client.fl) {
        //         if (client.fl.toLowerCase().includes(value)) {
        //             return true;
        //         }
        //     }
        //     if (client.pelephone) {
        //         if (client.pelephone.toLowerCase().includes(value)) {
        //             return true;
        //         }
        //     }
        //     if (client.comments) {
        //         if (client.comments.toLowerCase().includes(value)) {
        //             return true;
        //         }
        //     }
        //     return false;
        // });

        // this.dataView.first = 0;
        // this.dataView.el.nativeElement.children[0].scrollTo({ top: 0 });

        // // Set one of the states when the list is loaded
        // if (this.customers.length == 0) {
        //     this.state = "noresults";
        // }
        // else {
        //     this.state = "loaded";
        // }
    }

    // Lazy loading
    loadCustomersLazyAll(event?: LazyLoadEvent | undefined) {
        if (event) {
            this.lazyLoadParams = event;
        }

        this.customerAppointmentLazySearch.search = this.filterValue.toLowerCase();

        if (this.filterValue.length < 2) {
            this.loadCustomersLazy(this.lazyLoadParams);
        }
        else {
            this.loadCustomersLazySearch(this.lazyLoadParams);
        }
    }

    loadCustomersLazy(event: LazyLoadEvent) {
        // this.loadinglazy = true;

        this.customerAppointmentLazy.page = event.first / event.rows;
        this.customerAppointmentLazy.size = event.rows;
        this.customerAppointmentLazy.sortField = event.sortField;
        this.customerAppointmentLazy.sortOrder = event.sortOrder;

        // setTimeout(() => {
        this.httpService.getCustomersAppointmentLazy(this.customerAppointmentLazy)
            .then((response: CustomerAppointmentLazyOut) => {
                console.log(response)
                this.totalRecords = response.totalCount;

                this.customers = [...response.items];
                // this.initialCustomers = [...response.items];

                if (this.newCustomer) {
                    this.customers.unshift(this.newCustomer);
                    this.newCustomer = null;
                    this.totalRecords++;
                }

                if (!this.totalRecords) {
                    this.state = "noclients";
                }
                else {
                    this.state = "loaded";
                }

                // Set the phone numbers and the client's name with this number to sessionStorage to use them on another screen
                // let phoneNumbersSet = {};
                // let recommendersSet = [];
                // for (let i = 0; i < this.customers.length; i++) {
                //     if (this.customers[i].pelephone) {
                //         phoneNumbersSet[this.customers[i].pelephone] = this.customers[i].fl;
                //     }
                //     if (this.customers[i].customerId) {
                //         recommendersSet[this.customers[i].customerId] = this.customers[i].fl;
                //     }
                // }
                // sessionStorage.setItem("phoneNumbersSet", JSON.stringify(phoneNumbersSet));
                // sessionStorage.setItem("recommendersSet", JSON.stringify(recommendersSet));

                // this.loadinglazy = false;
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });
        // }, 1000);
    }

    loadCustomersLazySearch(event: LazyLoadEvent) {
        // this.loadinglazy = true;

        this.customerAppointmentLazySearch.page = event.first / event.rows;
        this.customerAppointmentLazySearch.size = event.rows;
        this.customerAppointmentLazySearch.sortField = event.sortField;
        this.customerAppointmentLazySearch.sortOrder = event.sortOrder;

        // this.customerLazySearch.search = this.filterValue.toLowerCase();

        // setTimeout(() => {
        this.httpService.getCustomersAppointmentLazySearch(this.customerAppointmentLazySearch)
            .then((response: CustomerAppointmentLazyOut) => {
                this.totalRecords = response.totalCount;

                this.customers = [...response.items];
                // this.initialCustomers = [...response.items];

                if (this.newCustomer) {
                    this.customers.unshift(this.newCustomer);
                    this.newCustomer = null;
                    this.totalRecords++;
                }

                if (!this.totalRecords) {
                    this.state = "noresults";
                }
                else {
                    this.state = "loaded";
                }

                // Set the phone numbers and the client's name with this number to sessionStorage to use them on another screen
                // let phoneNumbersSet = {};
                // let recommendersSet = [];
                // for (let i = 0; i < this.customers.length; i++) {
                //     if (this.customers[i].pelephone) {
                //         phoneNumbersSet[this.customers[i].pelephone] = this.customers[i].fl;
                //     }
                //     if (this.customers[i].customerId) {
                //         recommendersSet[this.customers[i].customerId] = this.customers[i].fl;
                //     }
                // }
                // sessionStorage.setItem("phoneNumbersSet", JSON.stringify(phoneNumbersSet));
                // sessionStorage.setItem("recommendersSet", JSON.stringify(recommendersSet));

                // this.loadinglazy = false;
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });
        // }, 1000);
    }

    // Show the form to add a new client
    addNewClient(): void {
        this.eventTitleChange.emit("הוספת לקוח/ה לתור");
        this.isAddingNewClient = true;
        this.firstNameValue = "";
        this.lastNameValue = "";
        this.pelephoneValue = "";
        this.sex = 0;
        this.isFormValid = true;
    }

    // Validate input
    isInputInvalid(input: NgModel): boolean {
        return input.invalid && !this.isFormValid;
    }

    // Validate phone input
    onPhoneInput(eventTarget: HTMLInputElement): void {
        if (this.pelephoneValue.length > 10) {
            this.pelephoneValue = this.pelephoneValue.slice(0, 10);
        }
        this.pelephoneValue = this.pelephoneValue.replace(/[^0-9]/g, "");
        eventTarget.value = this.pelephoneValue;
    }

    // Submit form to add new client
    submitForm(form: NgForm): void {
        if (form.valid) {
            this.firstNameValue = this.firstNameValue.trim();
            this.lastNameValue = this.lastNameValue ? this.lastNameValue.trim() : "";

            // if (this.pelephone && Object.keys(this.phoneNumbersSet).includes(this.pelephone)) {
            //     this.confirmDialogText = "כבר קיים לקוח בשם " + this.phoneNumbersSet[this.phone] + " עם טלפון זהה מה ברצוני לעשות?";
            //     this.isConfirmDialogVisible = true;
            // }
            // else {
            //     this.saveDataCustCard3();
            // }

            // const customer: CustomerAppointment = new CustomerAppointment();

            this.newCustomer = new CustomerAppointment();

            this.newCustomer.customerId = -99999;

            if (this.lastNameValue) {
                this.newCustomer.fl = this.firstNameValue + " " + this.lastNameValue;
            }
            else {
                this.newCustomer.fl = this.firstNameValue;
            }

            this.newCustomer.pelephone = this.pelephoneValue;
            this.newCustomer.sex = this.sex;

            // this.initialCustomers.unshift(customer);
            // this.customers.unshift(customer);

            this.isAddingNewClient = false;
            this.isAddButtonVisible = false;

            this.eventTitleChange.emit("בחירת לקוח");

            this.filterValue = this.newCustomer.fl;

            // setTimeout(() => {
            //     this.filterByInput();
            // }, 0);
        }
        else {
            this.isFormValid = false;
        }
    }

    // Cancel adding new client
    exitAdding(): void {
        this.filterValue = "";

        setTimeout(() => {
            this.filterByInput();
        }, 0);

        this.isAddingNewClient = false;

        this.eventTitleChange.emit("בחירת לקוח");
    }
}
